
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class EmailService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    listAccount(query?: any) {
        return this.get('/email/accounts',query);
    }

    createAccount(body: any) {
        return this.post('/email/account',body);
    }

    findAccount(id) {
        return this.get('/email/account/'+id);
    }

    updateAccount(id, body) {
        return this.put('/email/account/'+id, body);
    }

    deleteAccount(id) {
        return this.delete('/email/account/'+id);
    }

    listTemplate(query?: any) {
        return this.get('/email/templates',query);
    }

    createTemplate(body: any) {
        return this.post('/email/template',body);
    }

    findTemplate(id) {
        return this.get('/email/template/'+id);
    }

    updateTemplate(id, body) {
        return this.put('/email/template/'+id, body);
    }

    deleteTemplate(id) {
        return this.delete('/email/template/'+id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Email.service.ts